@if (loading) {
  <pr-loader></pr-loader>
}

<ea-simulation-packs
  [packService]="packService"
  [simulation]="simulation"
  (packSelected)="onPackSelected($event)"
  [withTable]="false"
  [withCustomPack]="false"
  [withPanelTitle]="false"
  [suitableBaseOnScore]="score"
>
</ea-simulation-packs>
<form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
